<ui-card
    role="listitem"
    [routerLink]="report.disabled || disableRouterLink ? null : [report.routerLink]"
    [clickable]="true"
    [disabled]="report.disabled ?? false"
    class="report"
>
    <h3 role="group" class="report-name">
        {{ report.name | translate }}
        <ng-content select="ui-badge" />
    </h3>
    {{ report.description | translate }}
</ui-card>
